// 1.first parameter is the current element
// 2.second parameter is the class name of a parent
// element that we need (no matter how many levels upper is it)
function findAncestor(el, cls){
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

// close current modal and
// open the one in the data-linkto attribute
function routingBetweenModals() {
  const allLinkedElements = document.querySelectorAll('.linkto');

  for (let i = 0; allLinkedElements.length > i; i++) {
    allLinkedElements[i].addEventListener('click', function() {
      const modal = findAncestor(this, 'popup-modal');
      let linkto = this.dataset.linkto;
      // hide current modal
      modal.style.display = 'none';
      // change the value of the Continue button
      // based on the country select
      if (linkto === 'custom') {
        linkto = modal.querySelector('.selected-country').dataset.validator;
        pushTheData(1, modal.querySelector('.current-country p').innerText);
      }
      // close the popup if the selected country:
      // 1) doesn't has a validation platform;
      // 2) is in the list.
      if (linkto === 'none') {
        if (modal.querySelector('.selected-country').
          getAttribute('data-value') === 'germany') {
          window.location.href = 'https://viforpharma-pro.de/';
          return false;
        }

        console.log('stored in local storage - 1');
        document.getElementById('login-popup').style.display = 'none';
        document.body.classList.remove('disable-scroll-hcp');
        localStorage.setItem('logged', 'true');
        return false;
      }

      //open the new modal
      if (document.getElementById(linkto)) {
        document.getElementById(linkto).style.display = 'block';
      }

      // close list with countries if exist in this modal
      if (modal.querySelector('.country-selector') &&
        modal.querySelector('.default-country-selector').style.display ===
        'block') {
        hideShowList(this);
      }
    });
  }
}

// show/hide the transparent cover of the continue button
function enableContinueButton(checkbox, enable){
  const parentModal = findAncestor(checkbox, 'popup-modal');
  let continueBtn;

  if(enable){
    continueBtn = parentModal.querySelector('.locked-button');
    // parentModal.querySelector(".continue-button-cover").style.display = 'none';
    continueBtn.removeAttribute('disabled');
  }else{
    continueBtn = parentModal.querySelector('.continue-button');
    continueBtn.setAttribute('disabled', true);
    // parentModal.querySelector(".continue-button-cover").style.display = 'block';
  }
  continueBtn.classList.toggle('locked-button');
  continueBtn.classList.toggle('continue-button');
}

// click on the checkbox
// select/unselect
function selectCheckbox() {
  const allCheckboxes = document.querySelectorAll('.countries-row .checkbox');

  for (let z = 0; allCheckboxes.length > z; z++) {
    allCheckboxes[z].addEventListener('click', function() {
      const checkSign = this.querySelector('i');

      if (checkSign.style.display === 'block') {
        checkSign.style.display = 'none';
        this.dataset.checked = 'none';
        enableContinueButton(this, false);
      }
      else {
        checkSign.style.display = 'block';
        this.dataset.checked = 'checked';
        enableContinueButton(this, true);
      }
    });
  }
}

// open/close countries list
function hideShowList(clickedSelector) {
  const modal = findAncestor(clickedSelector, 'popup-modal');
  const countrySelector = modal.querySelector('.country-selector');
  const countryList = countrySelector.querySelector('ul');
  const arrow = countrySelector.querySelector('i');

  if (countryList.style.display === 'block') {
    countryList.style.display = 'none';
  }
  else {
    countryList.style.display = 'block';
  }
  // rotate the arrow
  arrow.classList.toggle('rotate-arrow');
}

// open the list with countries
function openCountriesList() {
  const defaultCountry = document.getElementsByClassName('current-country');

  for (let r = 0; defaultCountry.length > r; r++) {
    defaultCountry[r].addEventListener('click', function() {
      hideShowList(this);
    });
  }
}

// unselect all the countries in the dropdown
function unselectAllCountries() {
  const allCountries = document.querySelectorAll(
    '#login-popup .default-country-selector li');

  for (let f = 0; allCountries.length > f; f++) {
    allCountries[f].classList.remove('selected-country');
  }
}

// click on a country in the list
function selectACountry() {
  const allCountries = document.querySelectorAll('#login-popup .default-country-selector li');

  for (let f = 0; allCountries.length > f; f++) {
    allCountries[f].addEventListener('click', function() {
      unselectAllCountries();
      this.classList.add('selected-country');
      setTheDefaultCountry(this.innerHTML, this);
      hideShowList(this);
    });
  }
}

// set the default country
function setTheDefaultCountry(country, element) {
  findAncestor(element, 'country-selector')
    .querySelector('.current-country')
    .innerHTML = country + '<i class="far fa-chevron-up"></i>';

  if(element.dataset.swiss && element.dataset.swiss === 'yes'){
    localStorage.setItem('swiss', 'yes');
  }else{
    localStorage.setItem('swiss', 'no');
  }
}

function userPermissionsCheck(){
  if(window.location.pathname.indexOf("activated")){
    if(document.getElementById("activated")) {
      localStorage.setItem("logged", "true");

    }
  }
}

// hide all not mandatory fields
function hideNotMandatoryFields() {
  const allFields = document.querySelectorAll('#opt-in input');

  for (let i = 0; allFields.length > i; i++) {
    if (allFields[i].hasAttribute('required') || allFields[i].type === 'submit') {
      console.log(allFields[i]);
    }
    else {
      allFields[i].style.display = 'none';
    }
  }
}

// docCheck activation
function docCheckActivation(){
  if (document.getElementById('activated')){
    localStorage.setItem("logged", "true");
    window.location.replace(window.location.origin);
  }
}

function pushTheData(step, country){
  console.log('step: '+step);
  console.log('country: '+country);

  dataLayer.push({
    'event': 'disclaimerComplete',
    'eventStep': 'Step '+step,
    'eventValue': country
  });
}
